import { Alert } from "@mui/material"

import GestaoVagaEnderecoGpsRow from "./GestaoVagaEnderecoGpsRow.jsx"
import GestaoVagaFilaRaioStatus from "./GestaoVagaFilaRaioStatus.jsx"
import GestaoVagaFilaAlertaProximidade from "./GestaoVagaFilaAlertaProximidade.jsx"
import GestaoVagaFilaPrazoStatus from "./GestaoVagaFilaPrazoStatus.jsx"
import {
	isMotivoProximidade,
	resolverChipStatusFila,
	resolverMotivoTipo,
	simplificarMotivoFila,
	textoDistanciaVagaFila,
} from "./gestaoVagaFilaUi.js"

/**
 * Card da fila — variantes de layout (agora = completo, outros = compacto).
 */
export default function GestaoVagaFilaCard({
	vaga,
	variant = "agora",
	destaque = false,
	atualizandoGeo = false,
	carregando = false,
	processandoId = 0,
	onAtualizarLocalizacao,
	onErroGps,
	onEntrarFila,
	onSairFila,
	onDetalhes,
	/** { tipo: 'success' | 'error', mensagem: string } — retorno da API logo acima dos botões */
	feedbackAcao = null,
}) {
	const chip = resolverChipStatusFila(vaga)
	const compacto = variant === "outros"
	const proximidade = isMotivoProximidade(vaga)
	const motivoTipo = resolverMotivoTipo(vaga)
	const mostrarMotivoGenerico =
		Boolean(vaga.motivo) &&
		!vaga.podeEntrarFila &&
		!vaga.naFila &&
		!proximidade &&
		!["prazo_encerrado", "jornada_encerrada", "aguardando", "atrasado", "reentrada_fila"].includes(
			motivoTipo
		)

	return (
		<article
			className={`gv-fila-card${compacto ? " gv-fila-card--compact" : ""}${
				destaque ? " gv-fila-card--destaque" : ""
			}${chip.variant === "danger" ? " gv-fila-card--atrasado" : ""}`}
		>
			<header className="gv-fila-card__header">
				<h2 className="gv-fila-card__titulo">{vaga.titulo || "Vaga"}</h2>
				<span className={`gv-chip gv-chip--${chip.variant} gv-chip--sm`}>{chip.label}</span>
			</header>

			{compacto ? (
				<p className="gv-fila-card__resumo m-0">
					{vaga.cidadeEstado || "—"}
					{textoDistanciaVagaFila(vaga) ? ` · ${textoDistanciaVagaFila(vaga)}` : ""}
					{vaga.dentroRaioFila ? " · no raio" : ""}
				</p>
			) : (
				<>
					<GestaoVagaFilaRaioStatus
						className="mb-2"
						vaga={vaga}
						onAtualizarLocalizacao={onAtualizarLocalizacao}
						atualizandoGeo={atualizandoGeo}
						carregando={carregando}
					/>
					<GestaoVagaEnderecoGpsRow vaga={vaga} onErroGps={onErroGps} />
				</>
			)}

			{vaga.jornadaHoje && vaga.horarioHoje ? (
				<p className="gv-fila-card__hoje m-0">
					<strong>Hoje:</strong> {vaga.horarioHoje}
				</p>
			) : null}

			<GestaoVagaFilaPrazoStatus vaga={vaga} compacto={compacto} />

			{vaga.naFila && !compacto ? (
				<Alert severity="success" className="mb-2 gv-alert-linha-toda gv-fila-card__alert">
					Sua posição:{" "}
					<strong>
						{vaga.posicaoFila} de {vaga.totalNaFila}
					</strong>
					{vaga.entrouEm ? ` · desde ${vaga.entrouEm}` : ""}
				</Alert>
			) : null}

			{vaga.naFila && compacto ? (
				<p className="gv-fila-card__linha-fila m-0">
					Posição <strong>{vaga.posicaoFila}/{vaga.totalNaFila}</strong>
				</p>
			) : null}

			<GestaoVagaFilaAlertaProximidade
				vaga={vaga}
				compacto={compacto}
				onAtualizarLocalizacao={onAtualizarLocalizacao}
				atualizandoGeo={atualizandoGeo || carregando}
				onErroGps={onErroGps}
			/>

			{mostrarMotivoGenerico ? (
				<Alert
					severity="warning"
					className={`gv-alert-linha-toda gv-fila-card__alert${
						compacto ? " gv-fila-card__alert--compact" : ""
					}`}
				>
					{simplificarMotivoFila(vaga)}
				</Alert>
			) : null}

			{compacto ? (
				<p className="gv-fila-card__hint m-0">Outros dias: toque em Detalhes.</p>
			) : null}

			{feedbackAcao?.mensagem ? (
				<Alert
					severity={feedbackAcao.tipo === "success" ? "success" : "error"}
					className="gv-alert-linha-toda gv-fila-card__feedback mb-2"
				>
					{feedbackAcao.mensagem}
				</Alert>
			) : null}

			<div className="gv-fila-card__acoes">
				{!compacto && vaga.podeEntrarFila ? (
					<button
						type="button"
						className={`btnFullW${chip.variant === "danger" ? " gv-fila-btn-urgente" : ""}`}
						disabled={processandoId === vaga.id}
						onClick={() => onEntrarFila?.(vaga.id)}
					>
						{processandoId === vaga.id ? "Entrando…" : "Entrar na fila"}
					</button>
				) : null}
				{!compacto && vaga.podeSairFila ? (
					<button
						type="button"
						className="btnBorder btnFullW"
						disabled={processandoId === vaga.id}
						onClick={() => onSairFila?.(vaga.id)}
					>
						{processandoId === vaga.id ? "Saindo…" : "Sair da fila"}
					</button>
				) : null}
				<button
					type="button"
					className={compacto ? "btnFullW" : "btnBorder btnFullW"}
					onClick={() => onDetalhes?.(vaga.id)}
				>
					Detalhes
				</button>
			</div>
		</article>
	)
}
